import styled from 'styled-components';
export const SummarySection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const SummaryCardContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 23px;
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const HR = styled.div`
    background-color: #cdcdcd;
    height: 1px;
    width: 100%;
`;
export const ReportsContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    @media (max-width: 1024px) {
        flex-direction: column;
        gap: 32px;
    }
`;
